// extracted by mini-css-extract-plugin
export default {"container":"Dk-z","links":"Ek-z"};